import React, { FC, useEffect, useState, useMemo } from "react"
import { useCreation } from "ahooks"
import echarts, { EChartOption } from "echarts"
import LayerAreaGeo from "./components/LayerAreaGeo"
import LayerIndustry from "./components/LayerIndustry"
import LayerNames from "./components/LayerNames"
import LayerPoi from "./components/LayerPoi"
import LayerHeat from "./components/LayerHeat"

import "echarts-amap"
import "./index.scss"
import { useSetState } from "@/reactUse"
const Map: FC<any> = (props) => {
  const chartsDomId = useMemo(() => {
    return "chartMap_" + Math.round(Math.random() * 10000000).toString(16)
  }, [])
  const [mapIns, setMapIns] = useState()
  const [chartIns, setChartIns] = useState<any>()
  const [state, setState] = useSetState({
    scaleX: 1,
    scaleY: 1,
    w: "100%",
    h: "100%",
  })
  const [zoom, setZoom] = useState(props.zoom)
  const [ready, setReady] = useState(false)

  useMemo(() => {
    setZoom(props.zoom)
  }, [props.zoom])

  const initialOption = useCreation<EChartOption | any>(() => {
    let opt = {
      animation: false,
      amap: {
        zoom: props.zoom,
        expandZoomRange: true,
        zooms: [3, 17],
        mapStyle: "amap://styles/dark", //地图主题
        center: props.center, //中心点
        rotation: 0, //顺时针旋转角度
        resizeEnable: true,
        zlevel: 999,
      },
      series: [],
      tooltip: {
        show: true,
        formatter: "{b}",
      },
    }

    return opt
  }, [])

  useMemo(() => {
    window.AMap.plugin("AMap.CustomLayer", () => {
      setReady(true)
    })
  }, [setReady])

  useEffect(() => {
    let dom = document.getElementById(chartsDomId)
    if (!dom) {
      return
    }
    // @ts-ignore
    let chartsIns = echarts.init(dom)
    chartsIns.setOption(initialOption)
    setChartIns(chartsIns)

    //@ts-ignore
    var map = chartsIns.getModel().getComponent("amap").getAMap()
    map &&
      map.on("zoomend", () => {
        setZoom(map.getZoom())
      })
    map &&
      map.on("click", (e) => {
        console.log("e", [e.lnglat.lng, e.lnglat.lat])
      })
    chartsIns.on("click", function (params) {
      console.log(params, chartsIns)
    })
    setMapIns(map)
    return () => {
      map && map.destroy()
      chartsIns.clear()
      chartsIns.dispose()
    }
  }, [ready, initialOption])

  useMemo(() => {
    // @ts-ignore
    mapIns && mapIns.setZoom(props.zoom)
  }, [mapIns, props.zoom])
  useMemo(() => {
    // @ts-ignore
    mapIns && mapIns.setCenter(props.center)
  }, [mapIns, props.center])
  useMemo(() => {
    // @ts-ignore
    chartIns && chartIns.setOption({ series: props.series })
  }, [chartIns, props.series])

  if (!ready) {
    return null
  }
  return (
    <div className="ct-map" style={{ height: "100%" }}>
      <div
        style={{
          width: state.w,
          height: state.h,
          // transform: `scale(${1 / state.scaleX}, ${1 / state.scaleY})`,
        }}
      >
        <div
          style={{
            width: state.w,
            height: state.h,
          }}
        >
          <div id={chartsDomId} style={{ height: "100%" }}></div>
          <LayerHeat
            visible={zoom > 8}
            district={props.district}
            map={mapIns}
          />
          <LayerAreaGeo
            visible
            data={props.geo}
            map={mapIns}
            store={props.store}
            activeProfileKey={props.activeProfileKey}
          />
          {/* <LayerIndustry visible data={props.pois} map={mapIns} /> */}
          <LayerPoi visible map={mapIns} store={props.store} />
          <LayerNames visible={zoom > 5} data={props.nameLabels} map={mapIns} />
        </div>
      </div>
    </div>
  )
}

export default Map
